import StreamMarker from '@classes/MapBox/StreamMarker';
import StreamSelector from '@components/views/creation/StreamSelector';
import { Box, Fade } from '@mui/material';
import { IStoreState } from '@store/index';
import React from 'react';
import { useSelector } from 'react-redux';

type SitesMapRightPanelProps = {
  onStreamClicked: (stream: VideoStream) => void;
  streamMarkers: StreamMarker[];
  focusedStream: string | undefined;
}

const SitesMapRightPanel: React.FC<SitesMapRightPanelProps> = (props) => {
  const { onStreamClicked, streamMarkers, focusedStream } = props;

  const selectedSite = useSelector((store: IStoreState) => store.selectedSites.selectedSite);
  const streams = useSelector((store: IStoreState) => store.streams.streams);

  const siteStreams = React.useMemo(() => {
    if (selectedSite) {
      return streams.filter(stream => {
        if (stream.siteId === selectedSite.siteId) {
          return true;
        }

        return false;
      });
    }

    return [];
  }, [selectedSite, streams]);

  const placedStreams = React.useMemo(() => {
    if (selectedSite) {
      return streams.filter(stream => Boolean(streamMarkers.find(el => el.getKvsName() === stream.kvsName)))
    }

    return [];
  }, [selectedSite, streamMarkers, streams])

  return (
    <Box width="100%" height="100%">
      <Fade in={Boolean(selectedSite)} timeout={{ appear: 200, exit: 0, enter: 2000 }}>
        <Box height="100%" padding="1rem">
          <StreamSelector
            streams={siteStreams}
            unavailableStreams={placedStreams}
            onDrag={() => { }}
            onDragEnd={() => { }}
            titleHeight={0}
            tileLayoutHeight={0}
            backPanelHeight={0}
            containerHeight={"76vh"}
            disabled={false}
            description="Click on cameras that are not yet placed on the map. You can move any cameras on the map by simly dragging them around."
            onClick={(stream) => { onStreamClicked(stream) }}
            focusedStream={focusedStream}
          />
        </Box>
      </Fade>
    </Box>
  )
}

export default SitesMapRightPanel;
